import { render, staticRenderFns } from "./SubmittedStartupsTable.vue?vue&type=template&id=0cae9b50&scoped=true&"
import script from "./SubmittedStartupsTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./SubmittedStartupsTable.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cae9b50",
  null
  
)

export default component.exports